/**
 * Social-login return page.
 *
 * Coderblock's OAuth relay redirects here after Google/GitHub consent with the
 * Supabase session in the URL fragment. We apply it (`supabase.auth.setSession`)
 * and bounce home. Do NOT link to this page — it's the OAuth callback target.
 *
 * The route path is fixed to `/auth/social/complete` (the relay's return path).
 */
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { completeSocialLogin } from '@/integrations/coderblock/auth'

export const route = { path: 'auth/social/complete' }

export default function AuthSocialCompletePage() {
  const navigate = useNavigate()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let active = true
    completeSocialLogin().then((result) => {
      if (!active) return
      if (result.ok) {
        navigate('/', { replace: true })
      } else {
        setError(result.error || 'Sign-in failed')
      }
    })
    return () => {
      active = false
    }
  }, [navigate])

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center gap-4 px-4 text-center">
      {error ? (
        <>
          <p className="text-lg font-semibold text-red-500">Sign-in failed</p>
          <p className="text-sm text-slate-500">{error}</p>
          <button
            onClick={() => navigate('/', { replace: true })}
            className="mt-2 rounded-lg bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-slate-700"
          >
            Back to app
          </button>
        </>
      ) : (
        <>
          <div className="h-8 w-8 animate-spin rounded-full border-2 border-slate-300 border-t-slate-900" />
          <p className="text-sm text-slate-500">Signing you in…</p>
        </>
      )}
    </div>
  )
}
